import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { RotateCcw, LayoutGrid, Trophy, Sparkles } from "lucide-react";

export const GameOverDialog = ({ open, score, points, best, isNewBest, modeName, timerOn, onPlayAgain, onMenu }) => (
  <Dialog open={open}>
    <DialogContent data-testid="game-over-modal" className="max-w-sm rounded-3xl border border-white/15 bg-slate-900/90 text-white backdrop-blur-2xl [&>button]:hidden">
      <DialogTitle className="font-display text-3xl font-black">Game Over</DialogTitle>
      <DialogDescription className="text-white/60">{modeName} mode · timer {timerOn ? "on (×2 points)" : "off"} · <span data-testid="final-rounds">{score}</span> rounds survived</DialogDescription>
      {isNewBest && (
        <div data-testid="new-best-banner" className="flex items-center gap-2 rounded-2xl bg-gradient-to-r from-amber-400 to-fuchsia-500 px-4 py-2 font-bold">
          <Sparkles className="h-5 w-5" /> New best score!
        </div>
      )}
      <div className="grid grid-cols-2 gap-3">
        <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
          <div className="text-xs uppercase tracking-widest text-white/50">Points</div>
          <div data-testid="final-score" className="font-display text-4xl font-black text-[#ffb703]">{points}</div>
        </div>
        <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
          <div className="flex items-center gap-1 text-xs uppercase tracking-widest text-white/50"><Trophy className="h-3 w-3" />Best</div>
          <div data-testid="final-best" className="font-display text-4xl font-black text-fuchsia-300">{best}</div>
        </div>
      </div>
      <div className="flex gap-3">
        <button data-testid="play-again-btn" onClick={onPlayAgain} className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gradient-to-r from-cyan-400 to-fuchsia-500 py-3 font-bold transition-transform hover:scale-105 active:scale-95">
          <RotateCcw className="h-4 w-4" /> Play Again
        </button>
        <button data-testid="change-mode-btn" onClick={onMenu} className="flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-3 font-bold transition-colors hover:bg-white/15">
          <LayoutGrid className="h-4 w-4" /> Modes
        </button>
      </div>
    </DialogContent>
  </Dialog>
);
